//@ts-nocheck

import React from 'react'
import { useParams } from 'react-router-dom'
import { IntegrationType } from 'server/mpsklad_core/Entity/IntegrationType'
import { YandexMarketSettingsPage } from '../../../../components/Settings/YandexMarket/YandexMarketSettingsPage'
import { WildberriesSettingsPage } from '../../../../components/Settings/Wildberries/WildberriesSettingsPage'
import { OzonSettingsPage } from '../../../../components/Settings/Ozon/OzonSettingsPage'
import { integrationKeyByType } from '../../../../types/integrationTypeUtils'
import { MoySkladAccountForm } from '../../../../components/MoySkladAccountForm'
import { Box } from '@material-ui/core'

export const MarketplaceSettingsSwitcher = () => {
  const {integration} = useParams<{integration: string}>()

  const integrationType = Number(Object.entries(integrationKeyByType)
                                       .find(([_, key]) => key === integration)?.[0])

  switch (integrationType) {
    case IntegrationType.YandexMarket:
      return <YandexMarketSettingsPage/>
    case IntegrationType.Wildberries: {
      return <WildberriesSettingsPage/>
    }
    case IntegrationType.Ozon:
      return <OzonSettingsPage/>
    case IntegrationType.MoySklad:
      return <Box style={{paddingTop: 37}}><MoySkladAccountForm/></Box>
    default:
      return null
  }
}